import { Navigate, Route, Routes } from 'react-router-dom';
import TestPage from 'public/pages/TestPage';
import { AllProducts } from '../../pages/AllProducts';
import { ListingsPage } from '../../pages/ListingsPage';
import { ListingDetailPage } from '../../pages/ListingDetailPage';
import { ListingSummaryPage } from '../../pages/ListingSummaryPage';
import MapPage from 'public/pages/MapPage';
import ProductPage from '../../pages/ProductPage';
import { Login } from '../../pages/Auth/Login';
import { Register } from '../../pages/Auth/Register';
import { AllDiscountProducts } from '../../pages/AllDiscountProducts';
import { AllFarms } from '../../pages/AllFarms';
import { IconsPage } from '../../pages/IconsPage';
import FarmPage from '../../pages/FarmPage';
import { AllNewProducts } from 'public/pages/AllNewProducts';
import { MyProfilePage } from '../../pages/MyProfilePage';
import { CartPage } from 'public/pages/CartPage';
import PublicRoute from 'enums/publicRoutes';
import { TermsOfUse } from 'public/pages/Auth/TermsOfUse';
import { OrderPage } from 'public/pages/OrderPage/OrderPage';
import { SearchPage } from '../../pages/SearchPage/SearchPage';
import WholesaleProductsRedirect from './WholesaleProductsRedirect';

const Router = () => {
  const renderRoutes = () => {
    return (
      <>
        <Route path={PublicRoute.MAP} element={<MapPage />} />
        <Route path={PublicRoute.PRODUCTS_ALL} element={<AllProducts />} />
        <Route
          path={PublicRoute.PRODUCTS_ALL_NEW}
          element={<AllNewProducts />}
        />
        <Route
          path={PublicRoute.PRODUCTS_ALL_DISCOUNTED}
          element={<AllDiscountProducts />}
        />
        <Route path={PublicRoute.FARMS_ALL} element={<AllFarms />} />
        <Route path={PublicRoute.FARM_PAGE} element={<FarmPage />} />
        <Route path={PublicRoute.TEST_PAGE} element={<TestPage />} />
        <Route path={PublicRoute.TERMS_OF_USE} element={<TermsOfUse />} />
        <Route path={PublicRoute.PRODUCT_PAGE} element={<ProductPage />} />
        <Route path={PublicRoute.HOME} element={<TestPage />} />

        <Route path={PublicRoute.LOGIN} element={<Login />} />
        <Route path={PublicRoute.REGISTER} element={<Register />} />
        <Route
          path={PublicRoute.NOT_FOUND}
          element={<Navigate to={PublicRoute.LOGIN} replace />}
        />
        <Route path={PublicRoute.ICONS_PAGE} element={<IconsPage />} />
        <Route path={PublicRoute.CART_PAGE} element={<CartPage />} />
        <Route path={PublicRoute.PROFILE} element={<MyProfilePage />} />
        <Route path={PublicRoute.USER_ORDER} element={<OrderPage />} />
        <Route path={PublicRoute.SEARCH_PAGE} element={<SearchPage />} />

        <Route
          path={PublicRoute.WHOLESALE_HOME}
          element={<Navigate to={PublicRoute.WHOLESALE_PRODUCTS_ALL} replace />}
        />
        <Route
          path={PublicRoute.WHOLESALE_PRODUCTS}
          element={<Navigate to={PublicRoute.WHOLESALE_PRODUCTS_ALL} replace />}
        />
        <Route
          path={PublicRoute.WHOLESALE_PRODUCTS_ALL}
          element={<AllProducts />}
        />
        <Route
          path={PublicRoute.WHOLESALE_PRODUCTS_ALL_NEW}
          element={<AllNewProducts />}
        />
        <Route
          path={PublicRoute.WHOLESALE_PRODUCTS_ALL_DISCOUNTED}
          element={<AllDiscountProducts />}
        />
        <Route path={PublicRoute.WHOLESALE_MAP} element={<MapPage />} />
        <Route path={PublicRoute.WHOLESALE_FARMS_ALL} element={<AllFarms />} />
        <Route path={PublicRoute.WHOLESALE_CART} element={<CartPage />} />
        <Route
          path={PublicRoute.WHOLESALE_PRODUCT_PAGE}
          element={<ProductPage />}
        />
        <Route path={PublicRoute.WHOLESALE_FARM_PAGE} element={<FarmPage />} />
        <Route
          path={PublicRoute.WHOLESALE_LISTINGS}
          element={<ListingsPage />}
        />
        <Route
          path={PublicRoute.WHOLESALE_LISTING_DETAIL}
          element={<ListingDetailPage />}
        />
        <Route
          path={PublicRoute.WHOLESALE_LISTING_SUMMARY}
          element={<ListingSummaryPage />}
        />
      </>
    );
  };

  return <Routes>{renderRoutes()}</Routes>;
};

export default Router;
